import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@fountain/ui-kit/components/grid';
import Form from '@fountain/ui-kit/components/form';
import Button from '@fountain/ui-kit/components/button';
import Link from '@fountain/ui-kit/components/link';

const propTypes = {
  disableEmailEditing: PropTypes.bool,
  gdprEnabled: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  invalid: PropTypes.bool.isRequired,
  submit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
};

const defaultProps = {
  disableEmailEditing: false,
};

export default function SignUpForm({
  disableEmailEditing,
  gdprEnabled,
  handleSubmit,
  invalid,
  submit,
  submitting,
}) {
  return (
    <Form onSubmit={handleSubmit(submit)}>
      <Grid>
        <Grid.Row>
          <Grid.Col sm="12">
            <Form.Input
              fullWidth
              id="email"
              readOnly={disableEmailEditing}
              name="email"
              placeholder="Email"
            />
          </Grid.Col>
        </Grid.Row>
        <Grid.Row>
          <Grid.Col sm="12" md="6">
            <Form.Input
              fullWidth
              id="firstName"
              name="firstName"
              placeholder="First Name"
            />
          </Grid.Col>
          <Grid.Col sm="12" md="6">
            <Form.Input
              fullWidth
              id="lastName"
              name="lastName"
              placeholder="Last Name"
            />
          </Grid.Col>
        </Grid.Row>
        <Grid.Row>
          <Grid.Col sm="12">
            <Form.Input
              fullWidth
              id="phoneNumber"
              name="phoneNumber"
              placeholder="Phone Number"
            />
          </Grid.Col>
        </Grid.Row>
        <Grid.Row>
          <Grid.Col sm="12">
            <Form.Password
              fullWidth
              id="password"
              name="password"
              placeholder="Password"
            />
          </Grid.Col>
        </Grid.Row>
        {gdprEnabled && (
          <Grid.Row>
            <Grid.Col sm="12">
              <Form.Checkbox
                id="agreementConsent"
                name="agreementConsent"
              >
                I have read and agree to Fountain&apos;s <Link href="//fountain.com/tos" target="_blank">terms of service</Link> and <Link href="//fountain.com/privacy" target="_blank">privacy policy</Link>
              </Form.Checkbox>
            </Grid.Col>
          </Grid.Row>
        )}
        <Grid.Row>
          <Grid.Col sm="12">
            <Button
              disabled={invalid || submitting}
              type="submit"
            >
              Create Account
            </Button>
          </Grid.Col>
        </Grid.Row>
      </Grid>
    </Form>
  );
}
SignUpForm.propTypes = propTypes;
SignUpForm.defaultProps = defaultProps;
